import { useQuery } from 'react-query'
import apiService from '../services/api'
import AdminLayout from '../components/AdminLayout'
import { Folder } from 'lucide-react'

const AdminCategories = () => {
  const { data, isLoading } = useQuery(
    ['admin-categories'],
    () => apiService.get('/rentman/categories').then(r => r.data)
  )
  const categories = data?.categories || data?.data || []

  return (
    <AdminLayout title="Administration" subtitle="Catégories">
        <div className="card">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="text-left py-3 px-4">ID</th>
                    <th className="text-left py-3 px-4">Nom</th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    <tr><td colSpan="2" className="py-12 text-center text-gray-600">Chargement…</td></tr>
                  ) : categories.length === 0 ? (
                    <tr><td colSpan="2" className="py-12 text-center text-gray-600">Aucune catégorie</td></tr>
                  ) : (
                    categories.map(c => (
                      <tr key={c.id} className="border-b border-gray-200 hover:bg-gray-50">
                        <td className="py-3 px-4">{c.id}</td>
                        <td className="py-3 px-4">{c.name || c.label}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
        </div>
    </AdminLayout>
  )
}

export default AdminCategories


